export default __webpack_public_path__ + "img/img_njtaylor-b001c9426275debc6d019bbb4e429a4f.jpg";